exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".error-boundary---2DwjI{display:flex;justify-content:center;align-items:center;min-height:200px;padding:20px;background-color:#f8f9fa;border-radius:8px;border:1px solid #dee2e6}.error-content---2KYBH{text-align:center;max-width:400px}.error-title---_vxfj{color:#dc3545;font-size:1.25rem;font-weight:600;margin-bottom:16px}.error-message---e2H9b{color:#6c757d;font-size:.875rem;line-height:1.5;margin-bottom:20px}", ""]);

// exports
exports.locals = {
	"error-boundary": "error-boundary---2DwjI",
	"error-content": "error-content---2KYBH",
	"error-title": "error-title---_vxfj",
	"error-message": "error-message---e2H9b"
};